export default { display: 'block', touchAction: 'none' } as React.CSSProperties
